import { Button } from "@design";
import { Hourglass } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import { STALL_AFTER_MS } from "@/streaming/useOperationStream";

/**
 * In place of the typing shimmer when a reply has had no news for a while (MHS-863): its worker may have died.
 * Stop ends it; Retry (when its message can be sent again) stops it, then sends the message again. It goes if news
 * comes.
 */
export function StalledNotice({
  retryable,
  onStop,
}: Readonly<{ retryable: boolean; onStop: (retry: boolean) => void }>) {
  const { t } = useTranslation("chat", { keyPrefix: "stalled" });
  return (
    <output
      aria-label={t("label")}
      className="flex flex-col gap-3 rounded-lg border border-border-subtle bg-surface-secondary px-4 py-3 md:flex-row md:items-center md:justify-between"
    >
      <div className="flex items-start gap-2">
        <Hourglass size={18} aria-hidden className="mt-0.5 shrink-0 text-content-secondary" />
        <div className="flex flex-col">
          <Text variant="body-sm">{t("title")}</Text>
          <Text variant="caption" tone="secondary">
            {t("hint", { count: STALL_AFTER_MS / 60_000 })}
          </Text>
        </div>
      </div>
      <div className="flex gap-2">
        {retryable && (
          <Button variant="primary" size="sm" onClick={() => onStop(true)}>
            {t("retry")}
          </Button>
        )}
        <Button variant="secondary" size="sm" onClick={() => onStop(false)}>
          {t("stop")}
        </Button>
      </div>
    </output>
  );
}
